module.exports = __webpack_public_path__ + "img/logo-cura.ad723000.jpg";